import React from 'react';

// import { DetailsChildrenTab } from 'app/main/components/page-layouts';
import { type DetailsPageProps } from 'app/main/components/page-layouts/details/DetailsPage';

import ErpOrdersDetailsTab from './tabs/ErpOrdersDetailsTab';
import ErpOrdersLinesTab from './tabs/ErpOrdersLinesTab';

export default [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ErpOrdersDetailsTab {...props} />
	},
	{
		id: 'lines',
		title: 'MODULE_ERP_ORDERS_LINES_NAME',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, refresh, updateRefresh }) => (
			<ErpOrdersLinesTab orderErpId={model.ords_erp_id} refresh={refresh} updateRefresh={updateRefresh} />
		)
	}
] as DetailsPageProps['tabs'];
